module.exports = __webpack_public_path__ + "static/media/fightbutton.1d75fc1c.png";